var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-group',{attrs:{"label":_vm.value.label}},[_c('b-form-select',{attrs:{"placeholder":_vm.value.label,"options":_vm.options},model:{value:(_vm.value.value),callback:function ($$v) {_vm.$set(_vm.value, "value", $$v)},expression:"value.value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }